import MentoringCurrentRequests from './MentoringCurrentRequests.vue';

export default MentoringCurrentRequests;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/currentrequests/index.ts